import 'whatwg-fetch'

import Vue from 'vue'

import './registerServiceWorker'
import './plugins/framework7'
import './plugins/leaflet'
import './plugins/atlas'
// import './plugins/socketio'

import store from './store'
import i18n from './i18n'
import App from './App'

Vue.config.productionTip = false

// eslint-disable-next-line
new Vue({
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
